import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=486e1c96&scoped=true&"
import script from "./Trends.vue?vue&type=script&lang=js&"
export * from "./Trends.vue?vue&type=script&lang=js&"
import style0 from "./Trends.vue?vue&type=style&index=0&id=486e1c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e1c96",
  null
  
)

component.options.__file = "Trends.vue"
export default component.exports